// TODO - Documentar

// Global constants
import * as con from '../../GlobalConstants'

// Style
import '../ComponentsGlobalStyle.css'

import { GenericElement } from '../../templates/FormElement';
import { translateBands } from '../../utils/translateFunctions';
import { AllApplicationParametersHook, EditApplicationParameterHook } from '../hooks/ApplicationParametersHooks';


function BandComparisonParameters () {

    const setSelectedVar = EditApplicationParameterHook(con.SELECTED_VAR)

    // Application Parameters
    // -----------------
    const applicationParameters = AllApplicationParametersHook()
    
    return (
        
        <div className='columnParameterBox' >
             < GenericElement type={con.MULTIPLE_SELECTION}
                         name={'Banda'}
                         id={con.SELECTED_VAR} 
                         value={applicationParameters[con.SELECTED_VAR]} 
                         setValue={(val) => setSelectedVar(val)} 
                         values={[con.VAR].concat(con.BANDS.map(b => `${b}_${con.VAR}`))}
                         valueLabels={["Oportunístico"].concat(con.BANDS.map((b) => translateBands(b)))}
                         />           

        </div>
    )
}

export default BandComparisonParameters 
